import { Alert, Col, Row } from 'antd'
import KCard from 'app/components/UI-Elements/DataDisplay/KCard'
import { ColorsPalette } from 'app/constants/GlobalStyles'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

const BILLING_EMAIL = 'billing@klarx.com'

const InvoiceUpload: React.FC = () => {
  const { tRecordType } = useTranslation({ recordType: 'invoice.upload' })

  return (
    <KCard title={tRecordType({ id: 'title' })}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Alert
            style={{ textAlign: 'center' }}
            message={
              <span style={{ color: ColorsPalette.textColor }}>
                {tRecordType({ id: 'description' })}
                <a
                  href={`mailto:${BILLING_EMAIL}`}
                  style={{
                    fontWeight: 'bold',
                    color: 'black',
                    textDecoration: 'underline'
                  }}>
                  {BILLING_EMAIL}
                </a>
              </span>
            }
            type="info"
          />
        </Col>
      </Row>
    </KCard>
  )
}

export default InvoiceUpload
